<template>
    <div class="alert alert-info">در حال انتقال به درگاه پرداخت اینترنتی ...</div>
    <form :action="form.url" :method="form.method" ref="form">
        <input v-for="(val, key) in form.fields" :key="key" type="hidden" :name="key" :value="val" />
    </form>
</template>

<script>
export default {
    name: "RedirectOnlinePayment",
    props: ["form"],
    mounted() {
        setTimeout(() => {
            this.$refs.form.submit();
        }, 3000);
    }
}
</script>

<style scoped>

</style>
